/**
 * Direct HR admin — Google login par auto HR (Firestore `users` doc).
 * Extra emails: HR → System → **Admin access** (settings/app.hrAdminEmails) + deploy `firestore.rules`.
 * Yahan sirf fallback / domain; optional hardcoded list.
 */

export const HR_ADMIN_EMAILS = [
  'lata.rai@acadxl.com',
  'mohibhar@gmail.com',
];

/** Optional: poora domain HR (jaise pehle techacadxl wali IDs) */
const HR_ADMIN_DOMAIN = 'techacadxl.com';

export function isHrBootstrapEmail(email) {
  if (!email) return false;
  const e = String(email).trim().toLowerCase();
  if (HR_ADMIN_EMAILS.some((x) => x.toLowerCase() === e)) return true;
  return e.endsWith(`@${HR_ADMIN_DOMAIN}`);
}
